// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BrewFormController from "./brew_form_controller"
application.register("brew-form", BrewFormController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ExcerptReviewController from "./excerpt_review_controller"
application.register("excerpt-review", ExcerptReviewController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageDropzoneController from "./image_dropzone_controller"
application.register("image-dropzone", ImageDropzoneController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UrlParseFormController from "./url_parse_form_controller"
application.register("url-parse-form", UrlParseFormController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)
